import React, { useRef } from 'react';
import { Modal, Table, InputNumber, Button } from 'antd';

const ProductInventoryModal = ({
  open,
  product,
  rows,
  saving,
  importLoading,
  onCancel,
  onSave,
  onImportFromFile,
  onVariantStockChange,
  getVariantDisplayName,
}) => {
  const inputRef = useRef(null);

  const onChooseFile = () => {
    inputRef.current?.click();
  };

  const onFileChange = async (event) => {
    const file = event?.target?.files?.[0];
    if (file && onImportFromFile) {
      await onImportFromFile(file);
    }
    event.target.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls"
        style={{ display: 'none' }}
        onChange={onFileChange}
      />
      <Modal
        title={`Cập nhật tồn kho - ${product?.name || ""}`}
        open={open}
        onCancel={onCancel}
        confirmLoading={saving}
        width={900}
        footer={[
          <Button key="import" onClick={onChooseFile} loading={importLoading}>
            Nhập từ file
          </Button>,
          <Button key="cancel" onClick={onCancel}>
            Đóng
          </Button>,
          <Button key="save" type="primary" loading={saving} onClick={onSave}>
            Lưu
          </Button>
        ]}
      >
      <Table
        pagination={false}
        rowKey="id"
        dataSource={rows}
        columns={[
          {
            title: 'Biến thể',
            render: (_, row) => getVariantDisplayName(row)
          },
          {
            title: 'Đã đặt',
            render: (_, row) => Number(row.reserved_quantity ?? 0)
          },
          {
            title: 'Số lượng tồn',
            render: (_, row) => (
              <InputNumber
                min={0}
                value={Number(row.next_on_hand_quantity ?? 0)}
                onChange={(val) => onVariantStockChange(row.id, val)}
              />
            )
          },
          {
            title: 'Khả dụng',
            render: (_, row) => Number(row.available_quantity ?? 0)
          }
        ]}
      />
      </Modal>
    </>
  );
};

export default ProductInventoryModal;
